import React, { useState } from 'react';
import { CloudArrowUp } from '@phosphor-icons/react';
import { Upload } from 'antd';

import { Button, Switch } from '../../components/general';
import { PageWrapper, ContentHeader } from '../../components/layout/content';

import { isEmpty, getBase64 } from '../../utils';

const Brand = () => {
  const brandLogo = JSON.parse(localStorage.getItem('brandLogo') ?? '{}');

  const [logo, setLogo] = useState(isEmpty(brandLogo) ? {} : brandLogo);
  const [isLogoUpload, setIsLogoUpload] = useState(isEmpty(brandLogo));
  const [isUseLogoCheck, setIsUseLogoCheck] = useState(true);

  const onChange = (info: any) => {
    getBase64(info.file.originFileObj, (url: string) => {
      const logo = { name: info.file.name, url: url };

      setLogo(logo);
      localStorage.setItem('brandLogo', JSON.stringify(logo));
      setIsLogoUpload(false);
    });
  };

  const onRemoveLogo = () => {
    setLogo({});
    localStorage.setItem('brandLogo', '{}');
    setIsLogoUpload(true);
  };

  return (
    <PageWrapper type="user-dashboard" title="Brand" className="gap-6">
      <ContentHeader
        title="Brand"
        subtitle="Upload a logo to overlay on your creations"
      />

      {isLogoUpload ? (
        <div className="flex flex-col gap-2">
          {!isEmpty(logo) && (
            <div className="flex items-center gap-2">
              <div>
                <b>Current logo</b>: {logo.name}
              </div>
              <img src={logo.url} alt="Logo" className="h-5 rounded-sm" />
            </div>
          )}

          <Upload.Dragger
            accept="image/*"
            multiple={false}
            onChange={(info) => onChange(info)}
            className="group"
          >
            <div className="h-80 flex flex-col items-center justify-center gap-4 px-4 text-lg">
              <CloudArrowUp
                className="fill-[url('#icon-primary-gradient')] group-hover:animate-jumping"
                size={100}
              />
              <div>Drag and drop or click to upload</div>
            </div>
          </Upload.Dragger>
        </div>
      ) : (
        <div className="flex flex-col gap-2">
          <Switch
            label="Use my logo"
            checked={isUseLogoCheck}
            onChange={() => setIsUseLogoCheck(!isUseLogoCheck)}
          />

          <div className="w-full h-96 flex items-center justify-center p-8 bg-grey-100 rounded-md border border-grey-900 border-solid">
            <img
              className="m-w-[90%] max-h-64 rounded-md"
              src={logo.url}
              alt="Logo"
            />
          </div>
        </div>
      )}

      {!isEmpty(logo) && (
        <div className="flex items-center justify-between">
          <Button variant="primary-thin" colour="grey" onClick={onRemoveLogo}>
            Remove Logo
          </Button>

          {isLogoUpload ? (
            <Button
              className="w-24"
              variant="primary-thin"
              onClick={() => setIsLogoUpload(false)}
            >
              Cancel
            </Button>
          ) : (
            <Button
              variant="primary-thin"
              onClick={() => setIsLogoUpload(true)}
            >
              Change Logo
            </Button>
          )}
        </div>
      )}
    </PageWrapper>
  );
};

export default Brand;
